/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Sync_SyncingInputs */

const cs_builder_sync_syncing = /** @type {(inputs: Builder_Sync_SyncingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronizace…`)
};

const en_builder_sync_syncing = /** @type {(inputs: Builder_Sync_SyncingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Syncing…`)
};

/**
* | output |
* | --- |
* | "Syncing…" |
*
* @param {Builder_Sync_SyncingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_sync_syncing = /** @type {((inputs?: Builder_Sync_SyncingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Sync_SyncingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_sync_syncing(inputs)
	return cs_builder_sync_syncing(inputs)
});